module.exports = __webpack_public_path__ + "img/gigas_giant_clam.0fa01567.png";